<!-- Translated: yes -->
<template>
  <Modal @close="localClose" :wide="false" width="545px" setClass="no-padding-ever" closeText="Nej tack, gå till varukorgen" :showClose="false">
    <div class="delivery-wrapper">
      <h2 v-if="possibleWithDelivery && (!SITE_CONFIG.rental.delivery_fee_active || SITE_CONFIG.rental.delivery_fee_price <= 0)">Spara tid – förboka utrustning med gratis utkörning
        <span v-if="accomodationsToSelect.length > 1">till {{accomodationsToSelect[0].title}}</span>
      </h2>
      <h2 v-if="possibleWithDelivery && SITE_CONFIG.rental.delivery_fee_active && SITE_CONFIG.rental.delivery_fee_price > 0">Spara tid – förboka utrustning med utkörning
        <span v-if="accomodationsToSelect.length > 1">till {{accomodationsToSelect[0].title}}</span>
      </h2>
      <h2 v-if="!possibleWithDelivery">Spara tid – förboka utrustning
      </h2>

      <ul v-if="possibleWithDelivery">
        <!-- <li>Inga köer, ingen trängsel.</li> -->
        <li>Allt är klart när du kommer hit.</li>
        <li v-if="SITE_CONFIG.rental.delivery_fee_active && SITE_CONFIG.rental.delivery_fee_price > 0">Valfri utkörning ({{ SITE_CONFIG.rental.delivery_fee_price }} kr per bokning).</li>
        <li v-else>Gratis utkörning och hämtning.</li>
        <li>Mer tid till skidåkning!</li>
      </ul>

      <div class="blocked info" v-if="possibleWithStorage">
        <b><icon name="info-blue" :scale="1" /> Obs! Nattförvaring</b>
        <p>Istället för utkörning har ditt boende ett förvaringsbås i skiduthyrningen fem meter från åkbar snö. I ditt skidnära bås kan du förvara dina skor under dagen så att du kan gå i dina bekväma skor till och från ditt boende.</p>
        <p v-if="accomodations.length > 1">&nbsp;</p>
      </div>

      <div class="blocked" v-if="(accomodation)">
        <b class="uppercase block">{{ $t('general.people-count') }}</b>
        <CounterButton ref="counterButton" class="counter-button" :inline="true" :count="peopleCount" :min="1" @changedCount="changePeople($event)" :suffix="' ' + $t('general.pieces-short')" />
      </div>

      <button v-if="possibleWithDelivery && (!SITE_CONFIG.rental.delivery_fee_active || SITE_CONFIG.rental.delivery_fee_price <= 0)" @click="startBooking()" :disabled="!validate">Boka gratis utkörning av utrustning</button>
      <button v-if="possibleWithDelivery && SITE_CONFIG.rental.delivery_fee_active && SITE_CONFIG.rental.delivery_fee_price > 0" @click="startBooking()" :disabled="!validate">Boka utkörning av utrustning</button>
      <button style="margin-top:1em;" class="white border" v-if="possibleWithDelivery" @click="startBookingNormal()" :disabled="!validate">Boka utrustning att hämta själv</button>
      <button v-if="!possibleWithDelivery" @click="startBookingNormal()" :disabled="!validate">Boka utrustning</button>
      <p><a class="close-link" href="#" @click.prevent="doClose()">Nej tack, jag bokar senare</a></p>

      <!-- <p class="small-info">För att undvika köer på plats uppmanar vi alla våra gäster att förboka både hyrutrustning och liftkort.<br>Hjälp oss att hålla avstånd!</p> -->

    </div>

    <div class="image">
    </div>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import CounterButton from '@/components/components/CounterButton';
import Modal from '@/components/components/Modal';
import CompletedBookings from '@/components/parts/CompletedBookings';
import SkiRentalDiscount from '@/components/components/SkiRentalDiscount';
import AccomodationCartItem from '@/classes/AccomodationCartItem';
import API from '@/classes/API';

import {
  validStartDate,
} from '@/dates';

import moment from 'moment';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    CompletedBookings,
    SkiRentalDiscount,
    CounterButton,
  },
  data() {
    return {
      peopleCount: 1,
      accomodation: null,
      unit: {},
      arrival: '',
      departure: '',
      accomodations: [],
      loading: false,
      selectedAccomodation: null,
      possibleWithStorage: false,
      possibleWithDelivery: true,
    };
  },
  computed: {
    canClose() {
      return !this.$store.state.isOnSite;
    },
    validStartDate() {
      return validStartDate({
        validStartDates: this.validStartDates,
      });
    },
    validate() {
      let errors = 0;
      errors += (this.peopleCount ? 0 : 1);
      errors += (this.params.type === 'with-delivery' && !this.accomodation ? 1 : 0);
      errors += (this.params.type === 'with-delivery' && !this.possibleWithDelivery ? 1 : 0);
      return !errors;
    },
    accomodationsToSelect() {
      const val = [];
      this.accomodations.forEach((accomodation, index) => {
        const arrival = moment(accomodation.arrival || accomodation.period.date_arrival).format('D[/]M');
        const departure = moment(accomodation.departure || accomodation.period.date_departure).format('D[/]M');
        val.push({
          value: index,
          title: (accomodation.unit ?
            (accomodation.unit.display_name
              || accomodation.unit.description_title) : accomodation.name),
          subtitle: `${arrival} - ${departure}`,
        });
      });
      return val;
    },
    ...mapGetters([
      'loggedIn',
      'guidedRentals',
    ]),
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
      'addRentalPeople',
      'confirmedAccomodations',
    ]),
    localClose() {
    },
    doClose() {
      this.closeModal();
      this.$router.replace('/varukorg');
    },
    goTo(path) {
      this.closeModal();
      this.$router.push({ path });
    },
    changePeople(payload) {
      this.peopleCount = payload;
    },
    startBooking() {
      let date = null;
      let days = null;

      date = this.accomodation.period.date_arrival;
      days = Math.round(moment(this.accomodation.period.date_departure).diff(
        this.accomodation.period.date_arrival) / 60 / 60 / 24 / 1000) + 1;

      this.addRentalPeople({
        peopleCount: this.peopleCount,
        pickedStartDate: date,
        numberOfDays: days,
        delivery: true,
        deliveryTo: this.unit,
        append: false,
      });

      if (date) {
        this.$store.state.cart.rentalDateRestriction = {
          date,
          days,
        };
      } else {
        this.$store.state.cart.rentalDateRestriction = {};
      }

      this.closeAllModals();

      this.$router.push({ path: '/skidhyra/0' });
    },
    startBookingNormal() {
      let date = null;
      let days = null;

      date = this.accomodation.period.date_arrival;
      days = Math.round(moment(this.accomodation.period.date_departure).diff(
        this.accomodation.period.date_arrival) / 60 / 60 / 24 / 1000) + 1;

      this.addRentalPeople({
        peopleCount: this.peopleCount,
        pickedStartDate: date,
        numberOfDays: days,
        delivery: false,
        deliveryTo: {},
        append: false,
      });

      if (date) {
        this.$store.state.cart.rentalDateRestriction = {
          date,
          days,
        };
      } else {
        this.$store.state.cart.rentalDateRestriction = {};
      }

      this.closeAllModals();

      this.$router.push({ path: '/skidhyra/0' });
    },
  },
  async mounted() {
    console.log('...reloading');
    const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
    const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

    if (confirmed.length) {
      this.accomodation = confirmed[0];
      this.accomodations = confirmed;
      this.unit = {
        pool_lid: this.accomodation.poolLid,
        unit_lid: this.accomodation.unitLid,
        name: this.accomodation.name,
      };
      this.arrival = this.accomodation.period.date_arrival;
      this.departure = this.accomodation.period.date_departure;

      this.$nextTick(() => {
        // Set people count
        this.peopleCount = AccomodationCartItem.peopleCount(confirmed[0]);
        if (this.$refs.counterButton) {
          this.$refs.counterButton.count = this.peopleCount;
        }
      });
    } else if (this.loggedIn && this.params.type === 'with-delivery') {
      await this.getAccomodations();
    }

    if (this.accomodation) {
      this.paramsType = 'with-delivery';

      const { success } = await API.get(`equipment-storage-available/${this.accomodation.poolLid}/${this.accomodation.unitLid}`);
      this.possibleWithStorage = success;

      const { data } = await API.get(`config/is-delivery-date-allowed?date=${this.accomodation.period.date_arrival}`);
      this.possibleWithDelivery = data;
    }

    // if (!confirmed.length) {
    //   this.$nextTick(() => {
    //     this.closeAllModals();
    //     this.openModal(['CartHighFiveModal', {
    //       ref: this.$route.query.ref,
    //       text: this.$route.query.text,
    //     }]);
    //   });
    // }
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h2
  font-size: 28px;
  font-weight: 700;
  font-family "Barlow"
  color deep-blue
  margin-top 0
  margin-bottom: 20px
  united-heavy()
  +max-mobile()
    font-size: 20px

.delivery-wrapper
  padding: 40px 80px 20px 80px;
  background-image: linear-gradient(180deg, #cfdce9, #f8f7f3);
  color deep-blue
  font-family Barlow
  font-weight 500
  font-size 16px
  border-top-left-radius 4px
  border-top-right-radius 4px
  +max-mobile()
    padding 8% 8%
    border-radius 0

  button
    font-family "Barlow Condensed"
    letter-spacing: 0.04em;
    border 0
    padding 0.8em 1.5em
    margin-top 1.5em
    margin-bottom 0.5em

.image
  background-image: url(https://static.booking.branasgruppen.se/static/img/skidhyra-delad-bild.jpg);
  background-position: top center
  background-size cover
  background-repeat no-repeat
  padding-top 78%
  border-bottom-left-radius 4px
  border-bottom-right-radius 4px

ul
  padding-left 0
  li
    padding-left 2.2em
    margin-bottom 1em
    background-image: url(https://static.booking.branasgruppen.se/static/svg/check-green-round.svg)
    background-size 16px
    background-repeat no-repeat
    background-size contain
    background-position 0 0
    list-style-type: none;

.uppercase.block
  font-size 12px
  margin-top 2.5em
  margin-bottom 1em

.close-link
  uppercase()
  text-decoration underline
  font-size 14px
  color deep-blue
  font-weight bold
  font-family "Barlow Condensed"
  margin-top 1em
  display inline-block

.small-info
  max-width 240px
  font-size 14px
  margin-top 2.5em
  max-width 335px

.info
  margin-top 1.5em
  margin-bottom 1em
</style>



// WEBPACK FOOTER //
// CartHighFiveAccomodationModal.vue?0ba4d284